export default __webpack_public_path__ + "static/media/slide-1.5ad34407.jpg";